import { Connection } from "@zapier/client";
import { ManagedConnectionSource } from "@zapier/shared";

import { ConnectionErrorCallbackPayload, ConnectionModal } from "./types";
import { ConnectionsRenameModal } from "./ConnectionsRenameModal";
import { ConnectionDeleteModal } from "./ConnectionsDeleteModal";
import { ConnectionChangeOwnerModal } from "./ConnectionChangeOwnerModal";
import { ConnectionShareModal } from "./ConnectionShareModal";
import AddConnectionModal from "./AddConnectionModal";
import { ConnectionsReplaceModal } from "./ConnectionsReplaceModal";

interface Props {
  currentConnections: Connection[];
  currentModal: ConnectionModal | undefined;
  // Attributes AddConnectionModal's created/abandoned events to a surface.
  managedConnectionSource?: ManagedConnectionSource;
  onConnectionError?: (error: ConnectionErrorCallbackPayload) => void;
  setCurrentConnection: (connection: Connection | undefined) => void;
  setCurrentModal: (modal?: ConnectionModal | undefined) => void;
}

export function ConnectionModals({
  currentConnections,
  currentModal,
  managedConnectionSource,
  onConnectionError,
  setCurrentConnection,
  setCurrentModal,
}: Props) {
  const currentConnection = currentConnections?.[0];

  const closeModal = () => {
    setCurrentConnection(undefined);
    setCurrentModal(undefined);
  };

  // Single connection
  const connectionId = currentConnection?.id;
  const connectionTitle = currentConnection?.title || "";

  return (
    <>
      <ConnectionsRenameModal
        id={connectionId}
        initialValue={connectionTitle}
        isOpen={currentModal === ConnectionModal.Rename}
        setIsOpen={closeModal}
      />
      <ConnectionDeleteModal
        id={connectionId}
        connectionTitle={connectionTitle}
        isOpen={currentModal === ConnectionModal.Delete}
        setIsOpen={closeModal}
      />
      <AddConnectionModal
        isOpen={currentModal === ConnectionModal.AddConnection}
        setIsOpen={closeModal}
        onConnectionError={onConnectionError}
      />
      <AddConnectionModal
        mode="managed"
        isOpen={currentModal === ConnectionModal.AddManagedConnection}
        setIsOpen={closeModal}
        onConnectionError={onConnectionError}
        source={managedConnectionSource}
      />
      <ConnectionChangeOwnerModal
        connection={currentConnection}
        id={connectionId}
        isOpen={currentModal === ConnectionModal.ChangeOwner}
        setIsOpen={closeModal}
      />
      <ConnectionShareModal
        connection={currentConnection}
        id={connectionId}
        isOpen={currentModal === ConnectionModal.Share}
        setIsOpen={closeModal}
      />
      <ConnectionsReplaceModal
        connection={currentConnection}
        id={connectionId}
        isOpen={currentModal === ConnectionModal.Replace}
        setIsOpen={closeModal}
      />
    </>
  );
}
